export default __webpack_public_path__ + "static/HAK-b59b77bcf16a2979dffe59069aac8111.png";